import type { TelemetryEvent } from '@ms/yammer-telemetry';
import { isAnalyticsV2Event } from '@ms/yammer-telemetry';

import type { YammerState } from '../../state/types';

import { getEtagFromStateOrPersistedState } from './selectors';

export type AddEtagToAnalyticsV2Event = <T extends YammerState>(
  event: TelemetryEvent,
  getState: () => T
) => Promise<TelemetryEvent>;
export const addEtagToAnalyticsV2Event: AddEtagToAnalyticsV2Event = async (event, getState) => {
  if (!isAnalyticsV2Event(event)) {
    return event;
  }

  const etag = await getEtagFromStateOrPersistedState(getState());
  if (!etag) {
    return event;
  }

  return {
    ...event,
    properties: {
      ...event.properties,
      ecsEtag: etag,
    },
  };
};
